<template>
  <form role="form">
    <div class="d-flex justify-content-between">
      <div class="col-12 form-group">
        <div class="row d-flex justify-content-between">
          <label class="form-control-label col-10">{{ topic.name }}<span class="text-red"> *</span></label>
          <el-tooltip
            :enterable="false"
            placement="top"
            content="Visualizar tabela de referência"
          >
            <span class="btn btn-sm btn-icon-only mr-3 mb-1" @click="references = true">
              <i class="fa fa-eye text-blue mt-2"></i>
            </span>
          </el-tooltip>
        </div>
        <multiselect
          v-model="topicInterval"
          :options="topic.interval"
          label="name"
          track-by="id"
          select-label=""
          deselect-label=""
          placeholder="Selecionar Resposta"
          @input="sendTopicParams"
          @open="$nextTick(() => $refs['interval'].scrollIntoView({ behavior: 'smooth', block: 'center' }))"
          :selected-label="'Selecionado'">
          <template slot="option" slot-scope="props">
            <div class="option__desc" ref="interval"><span class="option__title">{{ props.option.name }}</span></div>
          </template>
        </multiselect>  
        <div
          class="invalid-feedback"
          v-if="requiredField == true"
          style="display: block;"
        >
          Campo obrigatório
        </div>
        <modal :show.sync="references">
          <div class="row d-flex justify-content-between">
            <h5 class="col-7 modal-title mb-2" id="exampleModalLabel">Tabela de referência</h5>
            <span class="btn btn-sm btn-icon-only mr-3 mb-1" @click="references = false">
              <i class="fa fa-times mt-2"></i>
            </span>
            <h5 class="col-12 card-title text-uppercase text-muted mb-4 h5">{{ topic.name }}</h5>
          </div>
          <div v-for="interval in topic.interval" :key="interval.name">
            <div :class="[`${ setColor(interval.grade)}`]" class="card-body mb-2" style="max-height: 70px">
              <div class="d-flex justify-content-between">
                <h3 class="card-title text-white">{{ interval.name }}</h3>
                <h3 class="card-text text-white">{{ interval.grade }}</h3>
              </div>
            </div>
          </div>
        </modal>
      </div>
    </div>
  </form>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
export default {
  name: 'concept-form',
  components: { Multiselect },
  props: {
    topic: Object,
    requiredField: Boolean,
    clientCriId: Number
  },
  data() {
    return {
      references: false,
      topicInterval: this.topic.selectedInterval || {}
    }
  },
  methods: {
    setColor(nota) {
      if (nota < 50) {
        return 'bg-red'
      }
      else if (nota == 100) {
        return 'bg-success'
      }
      else {
        return 'bg-info'
      }
    },
    sendTopicParams () {
      let id = null
      if(this.topic.analisis) {
        id = this.topic.analisis.id
      }

      const data = {
        id: id,
        client_id: this.clientCriId,
        topic_concept_id: this.topic.id,
        interval_topic_concept_id: this.topicInterval ? this.topicInterval.id : null
      }
      
      if(data.interval_topic_concept_id != null) {
        this.$emit('topic-params', data)
      }
    }
  }
}
</script>
